import axios, {AxiosResponse} from "axios";
import {ID, Response} from "../../../../../_metronic/helpers";
import {PageContent, PageModel, UsersQueryResponse} from "./_model";
import {PostCategoryModel} from "../../../PostCategory/PostCategory_list/core/_models";
const API_URL = process.env.REACT_APP_API_URL
const USER_URL = `${API_URL}/api/v1/Page`



const getPosts = (query: string): Promise<UsersQueryResponse> => {
    return axios
        .get(`${USER_URL}/Get?${query}`)
        .then((d: AxiosResponse<UsersQueryResponse>) => d.data)
}

const getPostById = (id: any) => {
    return axios
        .get<PageModel>(`${USER_URL}/${id}`)

}
const createPost = (user: PageModel,url : string,file ? : any) => {
    const fd = new FormData();
    fd.append('Title', user.title || '');
    fd.append('DateString', user.dateString|| '');
    fd.append('Content', user.content|| '');
    fd.append('ShortDescription', user.shortDescription! || '' );
    fd.append('Keys', user.keys|| '');
    fd.append('Description', user.description|| '');
    fd.append('Id', user.id?.toString() || '');
    fd.append('PostType', user.postType!.toString() || '');
    fd.append('PicName', user.picName! || '');
    fd.append('Url', url);


    if(file){
        fd.append('File', file,file.name);
    }
    return axios.post(USER_URL, fd)

}

const updatePost = (user: PageModel,url : string,file ? : any) => {
    const fd = new FormData();
    fd.append('Title', user.title || '');
    fd.append('DateString', user.dateString|| '');
    fd.append('Content', user.content|| '');
    fd.append('shortDescription', user.shortDescription || '' );
    fd.append('Keys', user.keys|| '');
    fd.append('Description', user.description|| '');
    fd.append('Id', user.id?.toString() || '');
    fd.append('postType', user.postType!.toString() || '');
    fd.append('picName', user.picName || '');
    fd.append('Url', url);

    if(file){
        fd.append('File', file,file.name);
    }
    return axios
        .put(`${USER_URL}/${user.id}`, fd)

}

const deletePost = (userId: ID): Promise<void> => {
    return axios.delete(`${USER_URL}/${userId}`).then(() => {})
}

const deleteSelectedPosts = (userIds: Array<ID>): Promise<void> => {
    const requests = userIds.map((id) => axios.delete(`${USER_URL}/${id}`))
    return axios.all(requests).then(() => {})
}


export {

    getPosts,
    getPostById,
    createPost,
    updatePost,
    deletePost,
    deleteSelectedPosts,

}